import { Component, OnInit } from '@angular/core';
import { AccessibilityMessages } from '../../modules/shared/models/component-messages/accessibility-messages';

@Component({
  selector: 'app-accessibility',
  templateUrl: './accessibility.component.html',
  styleUrls: ['./accessibility.component.scss']
})
export class AccessibilityComponent implements OnInit {

  public accessibilityMessages = new AccessibilityMessages();

  constructor() {
  }

  public ngOnInit() {
  }
}
